import { createRequire } from 'node:module';
import path from 'node:path';
import 'node:fs/promises';
import { AbortError } from '@shopify/cli-kit/node/error';
import '@shopify/cli-kit/node/fs';
import { REQUIRED_REMIX_VERSION } from './remix-version-check.js';
import { findFileWithExtension } from './file.js';
import { isViteProject, REMIX_COMPILER_ERROR_MESSAGE, getViteConfig } from './vite-config.js';

async function hasRemixConfigFile(root) {
  const result = await findFileWithExtension(root, "remix.config");
  return !!result.filepath;
}
async function isClassicProject(root) {
  const isVite = await isViteProject(root);
  if (isVite) return false;
  return hasRemixConfigFile(root);
}
const BUILD_DIR = "dist";
const CLIENT_SUBDIR = "client";
const WORKER_SUBDIR = "worker";
function getProjectPaths(appPath) {
  const root = appPath ?? process.cwd();
  const publicPath = path.join(root, "public");
  const buildPath = path.join(root, BUILD_DIR);
  const buildPathClient = path.join(buildPath, CLIENT_SUBDIR);
  const buildPathWorkerFile = path.join(buildPath, WORKER_SUBDIR, "index.js");
  return {
    root,
    buildPath,
    buildPathClient,
    buildPathWorkerFile,
    publicPath
  };
}
function handleRemixImportFail() {
  const remixVersion = REQUIRED_REMIX_VERSION;
  throw new AbortError(
    "Could not load Remix packages.",
    `Please make sure you have \`@remix-run/dev@${remixVersion}\` installed and all the other Remix packages have the same version.`
  );
}
function getRawRemixConfig(root) {
  return findFileWithExtension(root, "remix.config").then(({ filepath }) => {
    if (!filepath) throw new AbortError("No remix.config.js file found.");
    return createRequire(import.meta.url)(filepath);
  });
}
async function getRemixConfig(root, mode = process.env.NODE_ENV) {
  if (!await isViteProject(root)) {
    throw new AbortError(REMIX_COMPILER_ERROR_MESSAGE);
  }
  return (await getViteConfig(root)).remixConfig;
}

export { getProjectPaths, getRawRemixConfig, getRemixConfig, handleRemixImportFail, hasRemixConfigFile, isClassicProject };
